import { useAdministrativeContext } from '../../../../../../pages/administrativePanel/administrativePanelContext'
import { useEffect, useState, useCallback } from 'react'
import { toast } from 'react-toastify'
import { api } from '../../../../../../services/api'
import { SpaceLoader } from '../../../../../loaders/spaceLoader'
import { GenericHorizontalBar } from '../../genericHorizontalBar'
import { useAuth } from '../../../../../../context/AuthContext'


export function BusinessesRanking() {
    const [isLoading, setIsLoading] = useState(true)
    const [animationBar, setAnimationBar] = useState(false)
    const [rankingDatasForGraphic, setRankingDatasForGraphic] = useState([])

    const { 
        startDate, 
        endDate, 
        listBusinessToFilter,
        listSalesChannelsId 
    } = useAdministrativeContext()

    const { signOut } = useAuth()

    const fetchData = useCallback(async () => {
        setIsLoading(true)

        let obj = {
            startDate: startDate,
            endDate: endDate,
            business: listBusinessToFilter,
            salesChannels: listSalesChannelsId
        }
  
        try{
            await api.post('/getRanking' , obj, {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            }).then(response => setRankingDatasForGraphic(response.data))
            setIsLoading(false)
            setAnimationBar(true)
        }catch(error){
            if(error.response){
                if(error.response.status === 401 || error.response.status === 500){
                    signOut()
                    toast.warning('Sua sessão foi expirada')
                }else{
                    toast.error(error.response.data.message)
                }
            }else{
                toast.error(error.message)
            }        
        }
    }, [endDate, signOut, startDate, listBusinessToFilter, listSalesChannelsId])
    
    
    useEffect(() => {
        let subscribed = true

        if(subscribed)
            fetchData()

        return () => (subscribed = false)
    }, [fetchData])

    
  
    if(isLoading)
        return <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" /> 

   
    return(
        <>
            {
                rankingDatasForGraphic.length > 0 ?
                <GenericHorizontalBar 
                    datasForGraphic={rankingDatasForGraphic} 
                    animationBar={animationBar}
                />
                :<p className="withoutInformations">Nenhuma informação</p>
            }
        </>
    )

}
